import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import Header from '../../components/Header/Header';
import { HomeWrapper } from '../GamePage/GamePage.styled';
import { StylePlayersContainer, StyleTopBar, StyleTransactionTable, StylePagination, StyledTableNameFilter, StyledSelect, StyledOption } from './UserMangePage.styled';
import { PlayerContext } from '../../contexts/playerContext';
import { RoleSelect } from './RoleSelect/RoleSelect';
import { updateUserRole } from '../../utils/updateUserRole';
import Input from '../../components/Input/Input';
import { BlockUser } from './BlockUser/BlockUser';
import { updateUserBlock } from '../../utils/updateUserBlock';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const UserMangePage: React.FC = () => {
  const playerContext = useContext(PlayerContext);
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [playerName, setPlayerName] = useState<string>("");
  const [searchRole, setSearchRole] = useState<string>("0");

  const limit = 10; // Items per page



  useEffect(() => {
    const fetchItems = async () => {
      try {
        const query = new URLSearchParams({
          playerName: playerName,
          searchRole: searchRole
        }).toString();

        const response = await fetch(`${API_ENDPOINT}/post/players/${page}/${limit}?${query}`);
        const data = await response.json();
        setItems(data.players);
        setTotalPages(data.totalPages);
        setTotalItems(data.totalItems);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };

    if (playerContext?.wallet.publicKey?.toString() == undefined) return;
    fetchItems();
  }, [page, playerContext?.wallet, playerName, searchRole]);

  useEffect(() => {
    if (playerContext?.role != 1) {
      navigate('/');
    }
  }, [])

  const handlePrevPage = () => setPage(prev => Math.max(prev - 1, 1));
  const handleNextPage = () => setPage(prev => Math.min(prev + 1, totalPages));

  const convertToLocalTime = (date: string) => {
    const localDate = new Date(date);
    return localDate.toLocaleString();
  }

  const shortenHash = (hash: string, startLength = 6, endLength = 4) => {
    if (!hash) return ""; // Handle cases where hash might be undefined or null
    return `${hash.slice(0, startLength)}...${hash.slice(-endLength)}`;
  }

  const handleChangeRole = async (id: string, role: string) => {
    const res = await updateUserRole(id, role);
  }

  const handleChangeBlock = async (id: string, blocked: boolean) => {
    const res = await updateUserBlock(id, blocked);
  }

  return (
    <HomeWrapper>
      <Header />
      <StylePlayersContainer>
        <StyleTopBar>
          <h2>Players</h2>
          <StyledTableNameFilter>
            <p>Player Name:</p>
            <Input width={'150px'} value={playerName} event={(e) => setPlayerName(e.target.value)} />
            <p style={{ marginLeft: '10px' }}>Role:</p>
            <StyledSelect onChange={(e) => setSearchRole(e.target.value)} defaultValue={0}>
              <StyledOption value={0}>All</StyledOption>
              <StyledOption value={1}>Super Admin</StyledOption>
              <StyledOption value={2}>Partner</StyledOption>
              <StyledOption value={3}>Player</StyledOption>
            </StyledSelect>
          </StyledTableNameFilter>

        </StyleTopBar>
        <p style={{ color: "#FFF", textAlign: 'end', fontSize: '14px' }}>{totalItems} results</p>
        <StyleTransactionTable>
          <thead>
            <tr>
              <th>No</th>
              <th>Name</th>
              <th>Address</th>
              <th>Tokens</th>
              <th>Deposit</th>
              <th>Withdraw</th>
              <th>Role</th>
              <th>Blocked</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {
              items.map((item: any, index) => (
                <tr key={index}>
                  <td>{(page - 1) * 10 + index + 1}</td>
                  <td>{item.name}</td>
                  <td><Link to={`https://solscan.io/account/${item.walletAddress}`} target="_blank" className="player-link">{shortenHash(item.walletAddress)}</Link></td>
                  <td>{item.balance / 1000} SOL</td>
                  <td>{(item.deposit | 0) / 1000} SOL</td>
                  <td>{(item.withdraw | 0) / 1000} SOL</td>
                  <td>
                    <RoleSelect role={item.role} handleChangeRole={handleChangeRole} id={item._id} />
                  </td>
                  <td>
                    <BlockUser blocked={item.blocked ? item.blocked : false} handleChangeBlock={handleChangeBlock} id={item._id} />
                  </td>
                  <td>{convertToLocalTime(item.created_at)}</td>
                </tr>
              ))
            }
          </tbody>
        </StyleTransactionTable>
        <StylePagination>
          <button onClick={handlePrevPage} disabled={page === 1}>
            Previous
          </button>
          <span> Page {page} of {totalPages} </span>
          <button onClick={handleNextPage} disabled={page === totalPages}>
            Next
          </button>
        </StylePagination>
      </StylePlayersContainer>
      <Footer />
    </HomeWrapper>
  );
};